import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../url';
import './Banners.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import logo from '../../images/logo.jpeg'; 

export default function Banners() {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [mobileImages, setMobileImages] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const swiperRef = useRef(null);
    const navigate = useNavigate(); // 👈 Hook de React Router para navegar internamente

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        cargarBanners();
    }, []);

    useEffect(() => {
        if (swiperRef.current) {
            swiperRef.current?.update();
        }
    }, [images, mobileImages]);

    const cargarBanners = () => {
        fetch(`${baseURL}/bannersGet.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                const bannerImages = data.banner
                    .filter(banner => banner.financiacion !== 1 && banner.isMobile !== 1)
                    .map(banner => banner.imagen);
                setImages(bannerImages);

                const smallBannerImages = data.banner
                    .filter(banner => banner.financiacion !== 1 && banner.isMobile === 1)
                    .map(banner => banner.imagen);
                setMobileImages(smallBannerImages);

                setLoading(false);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    // 👇 Ahora redirige internamente a /stock/autos
    const handleVerCatalogo = () => {
        navigate('/stock/autos');
    };

    const activeImages = isMobile ? mobileImages : images;

    return (
        <div className='BannerContain'>
            {loading ? (
                <div className='loadingBanner'>
                    <div className='catalog-button-container'>
                        <div className='catalog-content'>
                            <img
                                src={logo}
                                alt="Filoni Logo"
                                className="catalog-logo"
                            />
                            <p className='catalog-subtitle'>
                                "El auto que buscas, con la transparencia que mereces."
                            </p>
                            <button className='catalog-button' onClick={handleVerCatalogo}>
                                EXPLORA NUESTRO CATALOGO
                            </button>
                        </div>
                    </div>
                </div>
            ) : (
                <div className='banner-wrapper'>
                    <div className='catalog-button-container'>
                        <div className='catalog-content'>
                            <img
                                src={logo}
                                alt="Filoni Logo"
                                className="catalog-logo"
                            />
                            <p className='catalog-subtitle'>
                                "El auto que buscas, con la transparencia que mereces."
                            </p>
                            <button className='catalog-button' onClick={handleVerCatalogo}>
                                EXPLORA NUESTRO CATALOGO
                            </button>
                        </div>
                    </div>

                    <Swiper
                        modules={[Navigation, Pagination, Autoplay]}
                        grabCursor
                        loop
                        slidesPerView='auto'
                        coverflowEffect={{
                            rotate: 0,
                            stretch: 0,
                            depth: 100,
                            modifier: 2.5
                        }}
                        navigation={{
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev'
                        }}
                        autoplay={{ delay: 3000 }}
                        pagination={{ clickable: true }}
                        onSwiper={(swiper) => { swiperRef.current = swiper; }}
                        id='swiper_container'
                    >
                        {activeImages.map((image, index) => (
                            <SwiperSlide id='SwiperSlide-scroll' key={index}>
                                <img src={image} alt={`imagen-${index}`} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            )}
        </div>
    );
}
